import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getSummaryAvailability = createSelector(
  (state: Store) => state.dealManagement.commonDeal.summary.availability,
  (availability) => availability,
);

export const getSummaryAllocatedFrames = createSelector(
  [getSummaryAvailability],
  (availability) => availability.allocatedFrames,
);

export const getSummaryAllocatedImpressions = createSelector(
  [getSummaryAvailability],
  (availability) => availability.allocatedImpressions,
);

export const getSummaryAvailableFrames = createSelector(
  [getSummaryAvailability],
  (availability) => availability.availableFrames,
);

export const getSummaryAvailableImpressions = createSelector(
  [getSummaryAvailability],
  (availability) => availability.availableImpressions,
);

export const getSummaryTotalCost = createSelector([getSummaryAvailability], (availability) => availability.totalCost);

export const getSummaryAssets = createSelector([getSummaryAvailability], (availability) => availability.assets);

export const getSummaryDeliveredImpressions = createSelector(
  (state: Store) => state.dealManagement.commonDeal.summary.deliveredImpressions,
  (deliveredImpressions) => deliveredImpressions,
);

export const getSummaryCurrentRemainingImpressions = createSelector(
  (state: Store) => state.dealManagement.commonDeal.summary.currentRemainingImpressions,
  (currentRemainingImpressions) => currentRemainingImpressions,
);

export const getCampaignImpressionMetrics = createSelector(
  (state: Store) => state.dealManagement.commonDeal.impressionMetrics,
  (impressionMetrics) => impressionMetrics,
);
